export default __webpack_public_path__ + "static/media/Dr Anil Kumar.350cd7a7.jpg";